/* eslint-disable react/jsx-pascal-case */
import { message, Button, Col, ConfigProvider, Form, Tag, Row, Select, Space, Table, Modal, Popconfirm, InputNumber, Switch } from "antd";
import dayjs from 'dayjs';
import React, { useContext, useEffect, useRef, lazy, Suspense, useState } from "react";
import { default as ProTableOT } from "../../utility/ProTable_ot";
import { useNews } from "../controller/NewsController";
import NewsModal from "./NewsModal";
import NewsType from './NewsType'
import axios from 'axios';
const { ConfigContext } = ConfigProvider
const setParamsFilter = (obj) => {
    //拿掉值為空或是null 的東西
    return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
}
const News = ({
    defaultSize = 20,
    showSwitch = false,
    showNewsType = false,
    propsShowColumns = ["news_type_name", "news_title", 'news_type_name', 'news_time', 'open_status', 'staff_name', 'announce_time_end', 'news_weight_type_name', 'click_num', 'news_id', 'option'],
    propsCheckSelectRowKeys = [],
    propsCheckSelectedRowsInfo = [],
    propsMode = true,
    onCheckSelectChange = () => { },
    onClickEditNewsType = () => { }
}) => {
    axios.interceptors.request.use(
        async (config) => {
            const access_token = localStorage.getItem("access_token");

            if (access_token) {
                config.headers = {
                    ...config.headers,
                    authorization: `Bearer ${access_token}`,
                };
            }
            return config;
        },
        (error) => Promise.reject(error)
    );
    axios.interceptors.response.use(
        response => {
            return response
        },
        function (error) {
            const access_token_url = '/access_token';
            const config = error.config
            if (
                error.response?.status === 401 &&
                config.url === access_token_url
            ) {
                window.location.href = ('/login')
                return Promise.reject(error)
            }

            if (error.response?.status === 401 && !config._retry) {
                config._retry = true
                const refreshToken = localStorage.getItem('refresh_token')
                if (!refreshToken) window.location.href = ('/login')
                return axios
                    .post(access_token_url, {
                        refresh_token: refreshToken
                    })
                    .then(res => {
                        if (res?.status === 201) {
                            localStorage.setItem('access_token', res.data.access_token);
                            config.headers = {
                                ...config.headers,
                                authorization: `Bearer ${localStorage.getItem('access_token')}`,
                            };
                            return axios(config)
                        }
                    })
            }
            return Promise.reject(error)
        }
    )
    const [showColumns, setShowColumns] = useState(propsShowColumns ? propsShowColumns : ["news_type_name", "news_title", 'news_type_name', 'news_time', 'open_status', 'staff_name', 'announce_time_end', 'news_weight_type_name', 'click_num', 'news_id', 'option'])

    const columns = [
        {
            title: '分類',
            dataIndex: 'news_type_name',
            key: 'news_type_name',
        },
        {
            title: '標題',
            dataIndex: 'news_title',
            key: 'news_title',
        },
        {
            title: '公開狀態',
            key: "open_status",
            dataIndex: 'news_time',
            disabled: true,
            render: (text, record, index) => {
                let currentTime = dayjs()
                let news_time = dayjs(text, "YYYY-MM-DD HH:mm:ss")
                let isAnnounce = news_time.isBefore(currentTime)
                if (isAnnounce) {
                    return <Tag color="green">
                        已發佈
                    </Tag>
                }
                else {
                    return <Tag color="red">
                        未發佈
                    </Tag>
                }

            }
        },
        {
            title: '發佈者',
            dataIndex: 'staff_name',
            key: 'staff_name',
        },
        {
            title: '發佈時間',
            key: "news_time",
            dataIndex: 'news_time',

        },
        {
            title: '結束時間',
            key: "announce_time_end",
            dataIndex: 'announce_time_end',

        },
        {
            title: '重要程度',
            dataIndex: 'news_weight_type_name',
            key: 'news_weight_type_name',
        },
        {
            title: '點擊率',
            dataIndex: 'click_num',
            key: 'click_num',
        },
        {
            title: '消息連結',
            dataIndex: 'news_id',
            key: 'news_id',
            disabled: true,
            sorter: false,
            render: (text, record, index) => {
                return <Button
                    type="primary"
                    style={{
                        color: "#fff",
                        backgroundColor: "#A6A6A6"
                    }}
                    onClick={() => {
                        window.open('/officialweb/news/new/'+text)
                    }}
                >
                    點我前往
                </Button>
            }
        },
        {
            title: '操作',
            valueType: 'option',
            key: 'option',
            fixed: 'right',
            sorter: false,
            disabled: true,
            render: (text, record, _index) => {
                return (
                    <Space wrap>
                        <Button
                            type="link"
                            style={{
                                color: '#2BC17B'
                            }}
                            onClick={() => {
                                handleEditRow(record)
                            }}
                        >
                            修改
                        </Button>
                        <Popconfirm
                            title="刪除項目"
                            description="確定刪除勾選項目?"
                            onConfirm={() => handleDeleteRow(record?.news_id)}
                            onCancel={() => { }}
                        >
                            <Button
                                type="link"
                                danger>
                                刪除
                            </Button>
                        </Popconfirm>
                    </Space>
                )
            }
        },
    ];
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(defaultSize ? defaultSize : 20)
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([])
    const [checkSelectedRowKeys, setcheckSelectedRowKeys] = useState(propsCheckSelectRowKeys)
    const [checkSelectedRowsInfo, setcheckSelectedRowsInfo] = useState(propsCheckSelectedRowsInfo)
    const [mode, setMode] = useState(!!propsMode ) //true 編輯模式 false 勾選給上層模式
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            console.log({
                selected, selectedRows, changeRows
            })
            let select_temp = []
            let selectRow = []
            if (mode) {
                select_temp = [...selectedRowKeys]
                selectRow = [...selectedRowsInfo]
            }
            else {
                select_temp = [...checkSelectedRowKeys]
                selectRow = [...checkSelectedRowsInfo]
            }
            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.news_id)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.news_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            if (mode) {
                setSelectedRowKeys(select_temp)
                setSelectedRowsInfo(selectRow)
            }
            else {
                setcheckSelectedRowKeys(select_temp)
                setcheckSelectedRowsInfo(selectRow)
                onCheckSelectChange(select_temp, selectRow)
            }
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            console.log({
                record, selected, selectedRows, nativeEvent
            })
            let select_temp = []
            let selectRow = []
            if (mode) {
                select_temp = [...selectedRowKeys]
                selectRow = [...selectedRowsInfo]
            }
            else {
                select_temp = [...checkSelectedRowKeys]
                selectRow = [...checkSelectedRowsInfo]
            }
            if (selected) {
                select_temp.push(record.news_id)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.news_id)
                selectRow = selectRow.filter(row => row.news_id !== record.news_id)
            }
            if (mode) {
                setSelectedRowKeys(select_temp)
                setSelectedRowsInfo(selectRow)
            }
            else {
                setcheckSelectedRowKeys(select_temp)
                setcheckSelectedRowsInfo(selectRow)
                onCheckSelectChange(select_temp, selectRow)
            }
        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)

    const [form] = Form.useForm();

    const [axiosMode, setAxiosMode] = useState("get")
    const [showType, setShowType] = useState("News") // 顯示News OR NewsType
    const onCleanSelected = () => {
        if (mode) {
            setSelectedRowKeys([])
            setSelectedRowsInfo([])
        }
        else {
            setcheckSelectedRowKeys([])
            setcheckSelectedRowsInfo([])
        }

    }
    const handleAddRow = () => {
        setAxiosMode("post")
        setModalOpen(true)
        form.resetFields()
    }
    const handleEditRow = (record) => {
        setAxiosMode("patch")
        setModalOpen(true)
        let news_time = dayjs(record?.news_time, "YYYY-MM-DD HH:mm:ss")
        let announce_time_end = record?.announce_time_end ? dayjs(record?.announce_time_end, "YYYY-MM-DD HH:mm:ss") : record?.announce_time_end


        form.resetFields()
        form.setFieldsValue({
            ...record,
            news_time,
            announce_time_end
        })
    }
    const handleDeleteRow = (id) => {
        let data = []
        if (id) {
            data = [{
                news_id: id
            }]
        }

        else {
            data = selectedRowsInfo.map((val) => {
                return {
                    news_id: val?.news_id
                }
            })
        }
        if (data.length > 0) {
            deleteNewsData(data)
        }
        else {
            message.info("請選擇項目")
        }
    }

    const onFormFinish = (values) => {
        if (axiosMode === "post") {
            postNewsData([values])
        }
        else if (axiosMode === "patch") {
            patchNewsData([values])
        }
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])

            }
            setModalLoading(false)
            setModalOpen(false)
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                actionRef.current.reloadAndRest();
            }
            setModalLoading(false)
            setModalOpen(false)
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }

    const {
        getNewsData,
        postNewsData,
        patchNewsData,
        deleteNewsData,
    } = useNews({
        onFinish,
        onBefore,
    })
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useTableColumnsCheck(columns)
    useEffect(() => {
        checkAll()
    }, [])

    return <Row>
        {
            showType === "News" && (
                <Col span={24}>
                    <Row>
                        <Col>
                            <NewsModal
                                axiosMode={axiosMode}
                                propsOpen={modalOpen}
                                propsSetOpen={setModalOpen}

                                propsForm={form}

                                propsLoading={modalLoading}
                                propsSetLoading={setModalLoading}

                                onFinish={onFormFinish}
                            />
                        </Col>
                        <Col span={24}>
                            <ProTableOT
                                actionRef={actionRef}
                                headerTitle={<Space>
                                    {
                                        showSwitch && (
                                            <Switch
                                                checked={mode}
                                                checkedChildren="編輯模式"
                                                unCheckedChildren="綁定模式"
                                                onChange={(val) => {
                                                    setMode(val)
                                                    setShowColumns((pre) => {
                                                        if (val) {
                                                            if (!pre.includes("option")) {
                                                                return [...pre, 'option']
                                                            }
                                                            else {
                                                                return [...pre]
                                                            }
                                                        }
                                                        else {
                                                            return pre.filter((ele) => {
                                                                return ele !== "option"
                                                            })
                                                        }
                                                    })
                                                }}
                                            >

                                            </Switch>)
                                    }
                                    {mode && <Button
                                        type='primary'
                                        onClick={() => {
                                            handleAddRow()
                                        }}
                                        style={{
                                            backgroundColor: "#FFF9C9",
                                            color: "#000"
                                        }}
                                    >
                                        + 發佈消息
                                    </Button>}
                                    {mode && <Button
                                        type='primary'
                                        onClick={() => {
                                            if (showNewsType) {
                                                setShowType("NewsType")
                                            }
                                            else {
                                                onClickEditNewsType()
                                            }
                                        }}
                                        style={{
                                            backgroundColor: "#edf3ff",
                                            color: "#000"
                                        }}
                                    >
                                        編輯類別
                                    </Button>}


                                </Space>}
                                columns={columns.filter((element) => {
                                    return showColumns.includes(element.key)
                                })}
                                check={check}
                                setCheck={setCheck}
                                rowKey={'news_id'}
                                selections={{
                                    // onChange: (index_, data_) => set_data(data_)
                                }}
                                toolBarRender={() => [
                                    mode && <Popconfirm
                                        title="刪除消息"
                                        description="確定刪除勾選消息?"
                                        onConfirm={() => handleDeleteRow()}
                                        onCancel={() => { }}
                                    >
                                        <Button
                                            type='primary'
                                            style={{
                                                color: "#000",
                                                backgroundColor: "#ffedee"
                                            }}

                                        >
                                            刪除消息
                                        </Button>
                                    </Popconfirm>
                                ]}
                                extra_columns={extra_columns}
                                set_extra_columns={set_extra_columns}
                                manage_columns={false}
                                request={async (params = {}, sort, filter) => {
                                    console.log({
                                        params,sort,filter
                                    })
                                    setAxiosMode("get")
                                    let newParams = {
                                    };
                                    let order = setOrders(sort)
                                    newParams = {
                                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                        ...newParams,
                                        order,
                                        size: params.pageSize,
                                        cur_page: params.current,
                                        custom_filter_value: params.keyword ?? "",
                                        custom_filter_key: custom_filter_key
                                    };
                                    newParams = setParamsFilter({
                                        ...newParams,
                                    });
                                    setPageSize(params?.pageSize ?? 20)

                                    return getNewsData(newParams)
                                }}
                                pageSize={pageSize}
                                rowSelection={{
                                    type: 'checkbox',
                                    selectedRowKeys: mode ? selectedRowKeys : checkSelectedRowKeys,
                                    ...rowSelection,
                                }}
                                tableAlertOptionRender={() => {
                                    return (
                                        <Space size={16}>
                                            {/* <Typography.Link>匯出資料</Typography.Link> */}
                                        </Space>
                                    )
                                }}
                                tableAlertRender={({
                                    selectedRowKeys,
                                    selectedRows,
                                    // onCleanSelected,
                                }) => {
                                    return (
                                        <Space size={24}>
                                            <span>
                                                已選擇 {selectedRowKeys.length} 項
                                                <a style={{ marginInlineStart: 8 }} onClick={onCleanSelected}>
                                                    取消選擇
                                                </a>
                                            </span>
                                        </Space>
                                    );
                                }}
                                scroll={{
                                    x: "max-content"
                                }}

                            />
                        </Col>
                    </Row>
                </Col>
            )
        }
        {
            showType === "NewsType" && (
                <Col span={24}>
                    <NewsType
                        returnButtomText={showNewsType ? "返回":null   }
                        onClickReturnButtom={() => {
                            setShowType('News')
                        }}
                    />
                </Col>
            )
        }


    </Row>
}


const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([])
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    }
    const setOrders = (sorter) => {
        if (sorter) {
            let newOrders = Object.keys(sorter).map((key, index) => {
                if (sorter[key] === "descend") {
                    return JSON.stringify({
                        column: key,
                        type: 'DESC'
                    })
                }
                else {
                    return JSON.stringify({
                        column: key,
                        type: 'ASC'
                    })
                }

            })
            return newOrders
        }
        else {
            return []
        }
    }
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders
    }
}
export default News;
